import { request, Paginated } from "utils/api";
import { Club } from "api/clubs";

export enum ChallengeMetaType {
    STANDARD = "standard",
    BLUEPRINT = "blueprint",
    AUTO_JOIN_INVISIBLE = "auto-join-invisible",
}

export interface ChallengeRewards {
    rewardType: string,
    badgeTitle: string,
}

export interface AudienceGroups {
    anyOfSportForms?: string[];
    userId?: string;
    followeeUserId?: string;
    userIds?: string[];
    geographicAreaId?: string;
    clubMainSportForm?: string;
    clubUserRole?: string;
    challengeId?: string;
    internalTags?: string[];
    clubSite?: string;
    isActiveCompanyMember?: boolean;
}
export enum CompanySubscriptionType {
    STANDARD = "standard",
    ADVANCED = "advanced",
    ADVANCED_PLUS = "advanced_plus",
}
export interface Challenge {
    id: string,
    challengeName: string,
    description?: string,
    tags?: string[],
    startDate: Date,
    endDate: Date,
    sportForm: string,
    locationRestrictionType?: "none" | "geo-fence" | "check-in",
    companyClub: Club,
    challengeRewards: ChallengeRewards[],
    fulfillmentEvaluationType: string,
    numParticipants: number,
    numBookings: number,
    numMinutesPlayed: number,
    audienceGroups: AudienceGroups[],
    metaType: ChallengeMetaType,
    promotionScore: number,
    minimumCompanySubscriptionType: CompanySubscriptionType,
}

// fetch GET /admin/challenges
export const getAdminChallenges = (data: {
    clubId: string | undefined,
    query?: string,
    isBlueprint?: boolean,
    isActive?: boolean,
    tags?: string[],
    limit?: number,
    offset?: number,
}) => request<Paginated<Challenge>>({
    data,
    endpoint: "/admin/challenges",
    method: "get",
});

export interface ChallengePostParams {
    clubId?: string,
    startDate?: string,
    endDate?: string,
    challengeName?: string,
    blueprintChallengeId: string,
    description?: string,
    audienceGroups?: AudienceGroups[],
}

// fetch POST /admin/challenges
export const postAdminChallenges = (data: ChallengePostParams) => request<Challenge>({
    data,
    endpoint: "/admin/challenges",
    method: "post",
});
